// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"8c5038d5","512":"295c2f17","590":"26567d38","722":"cf411dad","724":"f165b940","753":"da9958f5","796":"9d78e68b"}[chunkId] + ".chunk.js";
};